import React, {ReactNode} from "react";
import {connect} from "react-redux";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import {Button, Paper, Typography} from "@material-ui/core";
import {Edit} from "@material-ui/icons";
import DatosPersonales from "./DatosPersonales";
import CambiarContra from "./CambiarContra";
import axios from "axios";
import {userService} from "../../../services/UserService";
import {ISections} from "../../../types";
import ConfigParcelas from "./ConfigParcelas";
import Notificaciones from "./Notificaciones";
import Idioma from "./Idioma";

const config = require('../../../config.json');
const texts = require('../../../texts/configuracion.json');


interface IProps {
    menu: boolean
    seccion: string
    idioma: string
    usuario: string
    level: number
    selectSection(section: ISections): void
    chooseConfigSection(seccion: string): void
}

interface IState {
    image: string
    hover: string
    update: boolean
    text: Record<string, string>
}

class Configuracion extends React.Component<IProps, IState> {
    state: IState = {
        image: config.url+`/static/usuarios/generic/perfil.png`,
        hover: '',
        update: false,
        text: texts[this.props.idioma]
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }
        return true
    }

    componentDidMount() {
        axios.get(config.url+`/static/usuarios/${userService.getUser()}/perfil.png`)
            .then(() => {
                this.setState({image: config.url+`/static/usuarios/${userService.getUser()}/perfil.png`})
            })
    }

    chooseSection = (): ReactNode => {
        switch (this.props.seccion) {
            case "datos_personales":
                return <DatosPersonales/>
            case "cambiar_contraseña":
                return <CambiarContra/>
            case "configuracion_parcelas":
                return <ConfigParcelas/>
            case "notificaciones":
                return <Notificaciones/>
            case "idioma":
                return <Idioma/>
            default:
                return <div style={{marginTop: 20}}>{this.state.text["0"]}</div>
        }
    };

    handleImage = (e: any) => {
        const data = new FormData();
        data.append('file', e.target.files[0]);
        axios.post(
            config.url+`/profile/image/upload`,
            data,
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }
            })
            .then(() => {
                this.props.selectSection('principal')
                this.props.selectSection('configuracion')
            })
            .catch(() => {
            })
    }


    render () {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignSelf: "start",
                    height: '100%',
                    width: '100%',
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />
                <div
                    style={{
                        height: '100%',
                        width: this.props.menu? '18%': '5%'
                    }}
                />

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        height: '100%',
                        width: this.props.menu? '82%': '95%'
                    }}
                >

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            height: 400,
                            width: '100%',
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >

                        <img
                            style={{
                                width: 200,
                                height: 200,
                                borderRadius: 100
                            }}
                            src={this.state.image}
                            alt={'img'}
                        />

                        <Paper
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center",
                                marginTop: -40,
                                marginRight: -150,
                                width: 40,
                                height: 40,
                                borderRadius: 20,
                                backgroundColor: this.state.hover === 'edit_image'? '#C7F9CC' : "white"
                            }}
                        >
                            <input
                                accept="image/png"
                                style={{
                                    display: 'none',
                                }}
                                id="profile-image"
                                type="file"
                                onChange={(e) => this.handleImage(e)}
                            />
                            <label htmlFor="profile-image">
                                <div
                                    style={{width: '100%', height: '100%', cursor: "pointer"}}
                                    onMouseEnter={() => this.setState({hover: 'edit_image'})}
                                    onMouseLeave={() => this.setState({hover: ''})}
                                >
                                    <Edit/>
                                </div>
                            </label>
                        </Paper>
                        <Typography
                            style={{
                                fontSize: 48,
                                fontWeight: "bold",
                                fontFamily: "Poppins"
                            }}
                        >
                            {userService.getUser()}
                        </Typography>
                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            width: '100%',
                            height: 'calc(80% - 300px)',
                        }}
                    >

                        <div style={{width: '15%'}}/>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                height: '100%',
                                width: '34%',
                                marginTop: 50
                            }}
                        >

                            <Button
                                style={{
                                    textTransform: "none",
                                    width: "fit-content",
                                    backgroundColor: this.props.seccion === 'datos_personales'? '#C7F9CC' : "white",
                                    borderRadius: 10
                                }}
                                onClick={() => this.props.chooseConfigSection('datos_personales')}
                            >
                                <Typography
                                    style={{
                                        fontSize: 28,
                                        fontWeight: "bold",
                                        color: "#4C494B",
                                        fontFamily: "Poppins"
                                    }}
                                >
                                    {this.state.text["1"]}
                                </Typography>
                            </Button>

                            <Button
                                style={{
                                    textTransform: "none",
                                    width: "fit-content",
                                    backgroundColor: this.props.seccion === 'cambiar_contraseña'? '#C7F9CC' : undefined,
                                    borderRadius: 10
                                }}
                                onClick={() => this.props.chooseConfigSection('cambiar_contraseña')}
                            >
                                <Typography
                                    style={{
                                        fontSize: 28,
                                        fontWeight: "bold",
                                        color: "#4C494B",
                                        fontFamily: "Poppins"
                                    }}
                                >
                                    {this.state.text["2"]}
                                </Typography>
                            </Button>

                            <Button
                                style={{
                                    textTransform: "none",
                                    width: "fit-content",
                                    backgroundColor: this.props.seccion === 'configuracion_parcelas'? '#C7F9CC' : undefined,
                                    borderRadius: 10
                                }}
                                onClick={() => this.props.chooseConfigSection('configuracion_parcelas')}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start"
                                    }}
                                >

                                    <Typography
                                        style={{
                                            fontSize: 28,
                                            fontWeight: "bold",
                                            color: "#4C494B",
                                            fontFamily: "Poppins"
                                        }}
                                    >
                                        {this.state.text["3"]}
                                    </Typography>
                                    {this.props.usuario !== userService.getUser() &&
                                        <Typography
                                            style={{
                                                fontSize: 28,
                                                fontWeight: "bold",
                                                color: "#4C494B",
                                                fontFamily: "Poppins"
                                            }}
                                        >
                                            {"("+this.state.text["34"]+" "+this.props.usuario+")"}
                                        </Typography>
                                    }
                                </div>
                            </Button>

                            <Button
                                style={{
                                    textTransform: "none",
                                    width: "fit-content",
                                    backgroundColor: this.props.seccion === 'notificaciones'? '#C7F9CC' : undefined,
                                    borderRadius: 10
                                }}
                                onClick={() => this.props.chooseConfigSection('notificaciones')}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start"
                                    }}
                                >

                                    <Typography
                                        style={{
                                            fontSize: 28,
                                            fontWeight: "bold",
                                            color: "#4C494B",
                                            fontFamily: "Poppins"
                                        }}
                                    >
                                        {this.state.text["4"]}
                                    </Typography>
                                    {this.props.usuario !== userService.getUser() &&
                                        <Typography
                                            style={{
                                                fontSize: 28,
                                                fontWeight: "bold",
                                                color: "#4C494B",
                                                fontFamily: "Poppins"
                                            }}
                                        >
                                            {"("+this.state.text["34"]+" "+this.props.usuario+")"}
                                        </Typography>
                                    }
                                </div>
                            </Button>

                            <Button
                                style={{
                                    textTransform: "none",
                                    width: "fit-content",
                                    backgroundColor: this.props.seccion === 'idioma'? '#C7F9CC' : undefined,
                                    borderRadius: 10
                                }}
                                onClick={() => this.props.chooseConfigSection('idioma')}
                            >
                                <Typography
                                    style={{
                                        fontSize: 28,
                                        fontWeight: "bold",
                                        color: "#4C494B",
                                        fontFamily: "Poppins"
                                    }}
                                >
                                    {this.state.text["32"]}
                                </Typography>
                            </Button>

                            {this.props.level === 5 &&
                                <Button
                                    style={{
                                        textTransform: "none",
                                        width: "fit-content",
                                        borderRadius: 10
                                    }}
                                    onClick={() => this.props.selectSection("Gestión de usuarios")}
                                >
                                    <Typography
                                        style={{
                                            fontSize: 28,
                                            fontWeight: "bold",
                                            color: "#4C494B",
                                            fontFamily: "Poppins"
                                        }}
                                    >
                                        {this.state.text["35"]}
                                    </Typography>
                                </Button>
                            }

                        </div>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                height: '100%',
                                width: '2%',
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                        >
                            <div
                                style={{
                                    height: '100%',
                                    width: 0,
                                    borderStyle: "solid",
                                    borderWidth: 2
                                }}
                            />
                        </div>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                height: '100%'
                            }}
                        >
                            {this.chooseSection()}
                        </div>

                    </div>

                </div>
            </div>
        )
    }


}


const mapStateToProps = (state: IStore) => ({
    menu: state.navegacion.menu,
    seccion: state.config.seccion,
    idioma: state.config.idioma,
    usuario: state.principal.usuario,
    level: state.navegacion.level
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    selectSection: (section: ISections) => dispatch({type: "select-section", section}),
    chooseConfigSection: (seccion: string) => dispatch({type: "choose-config-section", seccion}),
});

export default connect(mapStateToProps, mapDispatchToProps)(Configuracion);
